import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { RightsAccess } from '../../helper';
import MenuItem from '../MenuItem';
import { CriticalPathIcon, PlaceholderManagementIcon, PlanningIcon, ProductsIcon, RangePlanIcon } from '../../../bombiix-icon';

function PlaceholderUrl({ isMobileMenu }) {
  const reducer = useSelector((reducerstate) => reducerstate);

  const {
    Users: { moduleAccess, sectionAccess },
    UserDetails: { isSupplierLoggedIn },
  } = reducer;
  const { planningBottomUpRight, planningTopsDownRight, placeholderRight, rangePlanRight, productCriticalPathRight, operationalCriticalPathRight } =
    RightsAccess();

  const { planningAccess, placeholderAccess, rangePlanAccess, productsAccess, criticalPathAccess } = moduleAccess;

  const history = useHistory();
  const pathName = history.location.pathname;

  return (
    <ul>
      {productsAccess && (
        <MenuItem
          activeClassList={['/development-order-overview', '/modules-bulk-edit']}
          pathName={pathName}
          linkTo="/development-order-overview"
          IconComponent={ProductsIcon}
          titleKey="PLACEHOLDER_URL.PRODUCTS"
          isMobileMenu={isMobileMenu}
        />
      )}
      {planningAccess && !isSupplierLoggedIn && (planningTopsDownRight || planningBottomUpRight) && (
        <MenuItem
          activeClassList={['/planning/planning-actual', '/planning/planning-bottomup']}
          pathName={pathName}
          linkTo={sectionAccess?.planning?.topDownAccess && planningTopsDownRight ? '/planning/planning-actual' : '/planning/planning-bottomup'}
          IconComponent={PlanningIcon}
          titleKey="PLACEHOLDER_URL.PLANNING"
          isMobileMenu={isMobileMenu}
        />
      )}
      {placeholderAccess && !isSupplierLoggedIn && placeholderRight && (
        <MenuItem
          activeClassList={['/placeholder-management']}
          pathName={pathName}
          linkTo="/placeholder-management"
          IconComponent={PlaceholderManagementIcon}
          titleKey="PLACEHOLDER_URL.PLACEHOLDER_MANAGEMENT"
          isMobileMenu={isMobileMenu}
        />
      )}
      {rangePlanAccess && rangePlanRight && !isSupplierLoggedIn && (
        <MenuItem
          activeClassList={['/rangeplan/card-view', '/rangeplan/add', '/rangeplan/edit', '/rangeplan/product-list', '/rangeplan/archived']}
          pathName={pathName}
          linkTo="/rangeplan/card-view"
          IconComponent={RangePlanIcon}
          titleKey="PLACEHOLDER_URL.RANGE_PLAN"
          isMobileMenu={isMobileMenu}
        />
      )}
      {criticalPathAccess &&
        (sectionAccess?.criticalPath?.operationalAccess || sectionAccess?.criticalPath?.productAccess) &&
        (productCriticalPathRight || operationalCriticalPathRight) && (
          <MenuItem
            activeClassList={['operational-cp', '/product-cp']}
            pathName={pathName}
            linkTo={sectionAccess?.criticalPath?.operationalAccess && !isSupplierLoggedIn && operationalCriticalPathRight ? '/operational-cp' : '/product-cp'}
            IconComponent={CriticalPathIcon}
            titleKey="PLACEHOLDER_URL.CRITICAL_PATHS"
            isMobileMenu={isMobileMenu}
          />
        )}
    </ul>
  );
}

export default PlaceholderUrl;
